module.exports = __webpack_public_path__ + "static/media/pause.71515d89.svg";